import template from './alternate-sizes-item.html';
export var AlternateSizesItemComponent = {
    template: template,
    bindings: {
        item: '<'
    },
    controller: /** @class */ (function () {
        function AlternateSizesItemComponent(CartService, $mdDialog, googleAnalytic) {
            'ngInject';
            this.quantity = 1;
            this.processing = false;
            this.addedSuccessfully = false;
            var self = this;
            this.CartService = CartService;
            this.ga = googleAnalytic;
            this.addedSuccessfully = this.item.addedSuccessfully;
        }
        AlternateSizesItemComponent.prototype.increment = function () {
            this.quantity++;
        };
        AlternateSizesItemComponent.prototype.decrement = function () {
            this.quantity--;
        };
        AlternateSizesItemComponent.prototype.onAddItem = function () {
            var _this = this;
            if (!this.quantity)
                return false;
            this.processing = true;
            this.CartService.addItemQuantity(this.item.itemCode, this.quantity)
                .then(function (data) {
                _this.addedSuccessfully = true;
            })
                .catch(function (reason) {
                console.log({ error: true, reason: reason });
            })
                .finally(function () {
                _this.processing = false;
                _this.ga.sendEvent('EE Product Alternates', 'click', 'Add to Cart button click on Alternate Sizes Modal', 1);
            });
        };
        return AlternateSizesItemComponent;
    }())
};
//# sourceMappingURL=alternate-sizes-item.component.js.map